import { Component, OnInit } from '@angular/core';
import { AuthServiceService } from '../_services/AuthService.service';
import { AdminServiceService } from '../_services/AdminService.service';

@Component({
  selector: 'app-maindashboard',
  templateUrl: './maindashboard.component.html',
  styleUrls: ['./maindashboard.component.css']
})
export class MaindashboardComponent implements OnInit {

  isLoading = true;
  emailSummary: any;
  currentAction = "";
  currentUser:any;
  
  constructor(private _authService: AuthServiceService, private _adminService: AdminServiceService) { }

  ngOnInit() {
    this.currentUser = this._authService.decodedToken;
    this.loadEmailsSummary(this.currentUser.nameid);
  }

  onSummaryAction(action, message) {
    this.currentAction = action;
  }

  onEmailLogSelected(logSelected) {
    console.log('Log Selected: ', logSelected);
  }

  private loadEmailsSummary(userId: any) {
    this._adminService.getSubscriptionsSummaryByUserId(userId).subscribe(data => {
      this.isLoading = false;
      this.emailSummary = data;
    });
  }

}



// public barChartLabels = ['2006', '2007', '2008', '2009', '2010', '2011', '2012'];
// public barChartData = [
//   {data: [65, 59, 80, 81, 56, 55, 40], label: 'Series A'},
//   {data: [28, 48, 40, 19, 86, 27, 90], label: 'Series B'}
// ];
